import queryString from "query-string";
import { logEvent } from "@src/utils/logClient";
import { LocalStorageWrapper } from "@src/utils/localStorage";

const UTM_PARAMS_STORAGE_KEY = "marketing-utm-params";

const storeUtmParams = (parsedLocation: queryString.ParsedQuery<string>): void => {
  const utmParams: Record<string, string> = {};

  if (typeof parsedLocation.utm_source === "string") utmParams.utm_source = parsedLocation.utm_source;
  if (typeof parsedLocation.utm_medium === "string") utmParams.utm_medium = parsedLocation.utm_medium;
  if (typeof parsedLocation.utm_campaign === "string") utmParams.utm_campaign = parsedLocation.utm_campaign;
  if (typeof parsedLocation.utm_content === "string") utmParams.utm_content = parsedLocation.utm_content;
  if (typeof parsedLocation.utm_term === "string") utmParams.utm_term = parsedLocation.utm_term;

  if (Object.keys(utmParams).length > 0) {
    LocalStorageWrapper.setItem(UTM_PARAMS_STORAGE_KEY, JSON.stringify(utmParams));
  }
};

const logMarketingPageview = (location: Location): void => {
  const parsedLocation = queryString.parse(location.search);

  if (parsedLocation.utm_campaign) {
    storeUtmParams(parsedLocation);

    logEvent({
      eventName: `pageview.referrer_link`,
      // @ts-expect-error Type 'string | (string | null)[]' is not assignable to type 'string | number | undefined'.
      eventValue: parsedLocation.utm_campaign,
      metadata: parsedLocation,
    });
  }
};

export { logMarketingPageview, UTM_PARAMS_STORAGE_KEY };
